var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_401_28624",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_401_28624)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.2167 10.85C10.0944 10.7056 10.0333 10.5416 10.0333 10.358C10.0333 10.1749 10.0944 10.0222 10.2167 9.9L11.45 8.66667H6.66667C6.47778 8.66667 6.31956 8.60267 6.192 8.47467C6.064 8.34711 6 8.18889 6 8C6 7.81111 6.064 7.65267 6.192 7.52467C6.31956 7.39711 6.47778 7.33333 6.66667 7.33333H11.45L10.2167 6.1C10.0833 5.96667 10.0167 5.80844 10.0167 5.62533C10.0167 5.44178 10.0833 5.28333 10.2167 5.15C10.3389 5.01667 10.4918 4.95 10.6753 4.95C10.8584 4.95 11.0111 5.01111 11.1333 5.13333L13.5333 7.53333C13.6 7.6 13.6473 7.67222 13.6753 7.75C13.7029 7.82778 13.7167 7.91111 13.7167 8C13.7167 8.08889 13.7029 8.17222 13.6753 8.25C13.6473 8.32778 13.6 8.4 13.5333 8.46667L11.1333 10.8667C10.9889 11.0111 10.8307 11.0749 10.6587 11.058C10.4862 11.0416 10.3389 10.9722 10.2167 10.85ZM3.33333 14C2.96667 14 2.65267 13.8696 2.39133 13.6087C2.13044 13.3473 2 13.0333 2 12.6667V3.33333C2 2.96667 2.13044 2.65267 2.39133 2.39133C2.65267 2.13044 2.96667 2 3.33333 2H7.33333C7.52222 2 7.68067 2.06378 7.80867 2.19133C7.93622 2.31933 8 2.47778 8 2.66667C8 2.85556 7.93622 3.01378 7.80867 3.14133C7.68067 3.26933 7.52222 3.33333 7.33333 3.33333H3.33333V12.6667H7.33333C7.52222 12.6667 7.68067 12.7307 7.80867 12.8587C7.93622 12.9862 8 13.1444 8 13.3333C8 13.5222 7.93622 13.6804 7.80867 13.808C7.68067 13.936 7.52222 14 7.33333 14H3.33333Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.d609013d7477031bff16176dfbe35733.svg";
export { ForwardRef as ReactComponent };